import { getSubject } from './index';
import { isLessonWired } from './wired-kps';
import { getUiSoundPlayer } from '../ui-sounds';
import { mountBackButton } from '../nav/back-button';
import type { Subject } from '../../shared/types';

export interface ChapterPageActions {
  onSelectKP: (subjectId: Subject, kpId: string) => void;
  onBack: () => void;
}

export function renderChapterPage(
  container: HTMLElement,
  subjectId: Subject,
  chapterNum: number,
  actions: ChapterPageActions,
): void {
  const s = getSubject(subjectId);
  const c = s?.chapters.find(ch => ch.number === chapterNum);
  if (!s || !c) { actions.onBack(); return; }

  const root = document.createElement('div');
  root.className = 'chapter-page formal-page';
  // boss 2026-06-14「回上一頁方式要統一」:移除舊「回章節列表」inline 鈕,
  // 改用左上統一 ‹ 返回(mountBackButton)+ 左緣滑動。
  root.innerHTML = `
    <h1>第 ${c.number} 章:${c.title}</h1>
    <p>${s.emoji} ${s.label} (${s.textbook})</p>
    <div class="kp-list"></div>
  `;
  container.appendChild(root);

  // 統一 ‹ 返回:與 academy / 章節清單同一顆 ‹ + 集中式返回堆疊(左緣滑動共用)。
  const back = (): void => { offBack(); root.remove(); actions.onBack(); };
  const offBack = mountBackButton(root, { onBack: back });

  const list = root.querySelector('.kp-list')!;
  for (const k of c.kps) {
    const item = document.createElement('div');
    const wired = isLessonWired(k.id);
    const isClickable = k.status === 'ready' && wired;
    item.className = 'library-card' + (isClickable ? '' : ' disabled');
    const meta = isClickable
      ? '開始學習'
      : wired
        ? '製作中'
        : '📝 課程準備中';
    item.innerHTML = `
      <div class="lc-title">${k.label}</div>
      <div class="lc-meta">${meta}</div>
    `;
    if (isClickable) {
      item.addEventListener('click', () => {
        getUiSoundPlayer().play('ui-click', 0.3);
        offBack();
        root.remove();
        actions.onSelectKP(subjectId, k.id);
      });
    }
    list.appendChild(item);
  }
}
